import type { FC } from "react";

import { Button } from "src/components";
import { Routes } from "src/routes";
import { usePayoutPaymentMutation } from "src/serverApi";
import { useTranslation } from "src/translations";
import type { DocumentId } from "src/types";
import { logger } from "../logger";
import { PayError } from "./PayError";

type PayoutPayProps = Readonly<{
    orderDocumentId: DocumentId;
    onPay: () => void;
}>;

export const PayoutPay: FC<PayoutPayProps> = ({ orderDocumentId, onPay }) => {
    const { t } = useTranslation();

    const [pay, { isLoading, isError }] = usePayoutPaymentMutation();

    const handlePay = async () => {
        try {
            const { uri } = await pay({ orderDocumentId, returnUri: `${window.location.origin}${Routes.orders.path}` }).unwrap();
            onPay();
            window.location.href = uri;
        } catch (error) {
            logger.error("PayoutPay", error);
        }
    };

    return (
        <>
            {isError && <PayError error={t("orders.pay.gateway.error", { method: "Payout" })} />}
            <Button isLoading={isLoading} onClick={handlePay} className="mx-auto w-full">
                {t("orders.pay.gateway.payout")}
            </Button>
        </>
    );
};
